import { Injectable } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import {
    IOnboardingReportContainer,
    IOnboardingReportData,
    IOnboardingReportParameter,
    IOnboardingReportParticipantDetails,
    IOnboardingReportRecentActivity,
    IOnboardingReportWidget,
    IOnboardingReportWidgetFilter,
    IOnboardingUserUnitAccessData,
} from '@fi-app/fi-onboarding/fi-onboarding-report/fi-onboarding-report';
import { IItemsListDataFetchResult, IItemsListParameterBase } from '@fi-shared/fi-items-list/fi-items-list';

@Injectable()
export class FiOnboardingReportService {
    constructor(
        private fiBackend: FiBackendService,
        private fiLoading: LoadingService,
    ) {}

    getReportContainer(): Promise<IOnboardingReportContainer> {
        const promise = this.fiBackend.fetchData<IOnboardingReportContainer>(
            'Onboarding/OnboardingReport/GetReportContainer',
        );
        return this.fiLoading.trackPromise(promise);
    }

    getOnboardingRecentActivityListData(
        parameter: IItemsListParameterBase,
    ): Promise<IItemsListDataFetchResult<IOnboardingReportRecentActivity>> {
        const promise = this.fiBackend.fetchDataPost<IItemsListDataFetchResult<IOnboardingReportRecentActivity>>(
            'Onboarding/OnboardingReport/GetOnboardingRecentActivityListData',
            parameter,
        );
        return this.fiLoading.trackPromise(promise);
    }

    getReportData(parameter: IOnboardingReportParameter) {
        const promise = this.fiBackend.fetchDataPost<IOnboardingReportData>(
            'Onboarding/OnboardingReport/GetReportData',
            parameter,
        );
        return this.fiLoading.trackPromise(promise);
    }

    getOnboardingUserUnitAccessData(parameter: IOnboardingReportParameter) {
        return this.fiBackend.fetchDataPost<IOnboardingUserUnitAccessData[]>(
            'Onboarding/OnboardingReport/GetOnboardingUserUnitAccessData',
            parameter,
        );
    }

    getOnboardingCompletions(
        currentFilter: IOnboardingReportWidgetFilter,
    ): Promise<IOnboardingReportParticipantDetails> {
        const promise = this.fiBackend.fetchDataPost<IOnboardingReportParticipantDetails>(
            'Onboarding/OnboardingReport/GetOnboardingCompletions',
            currentFilter,
        );
        return promise;
    }

    saveReportWidget(widget: IOnboardingReportWidget): Promise<number> {
        const promise = this.fiBackend.fetchDataPost<number>('Onboarding/OnboardingReport/SaveReportWidget', widget);
        return this.fiLoading.trackPromise(promise);
    }

    deleteReportWidget(widgetId: number): Promise<void> {
        const promise = this.fiBackend.fetchDataPost<void>(
            `Onboarding/OnboardingReport/DeleteReportWidget/${widgetId}`,
        );
        return this.fiLoading.trackPromise(promise);
    }

    // todo: same in the task reports module
    getReportCount(): Promise<number> {
        // todo: we need to know what sort index is the last one
        return Promise.resolve(10);
    }
}
